/**
 * Translation-specific translation keys
 */
export const translation = {
  list: {
    search_placeholder: "admin.translation_list_search_placeholder",
    main_heading: "admin.translation_list_main_heading",
    table: {
      key_table_col_heading: "admin.translation_list_table_key_table_col_heading",
      value_table_col_heading: "admin.translation_list_table_value_table_col_heading",
      action_table_col_heading: "admin.translation_list_table_action_table_col_heading",
    },
    create_translation_btn_text: "admin.create_translation_btn_text",
    import_translation_btn_text: "admin.import_translation_btn_text",
    export_translation_btn_text: "admin.translation_list_export_translation_btn_text",
    sync_translation_btn_text: "admin.translation_list_sync_translation_btn_text",
    delete_popup_heading_text: "admin.translation_list_delete_popup_heading_text",
    delete_popup_yes_btn_text: "admin.translation_list_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.translation_list_delete_popup_no_btn_text",
    clear_filter_btn_text: "admin.translation_list_clear_filter_btn_text",
  },
  add: {
    main_heading: "admin.translation_add_main_heading",
  },
  edit: {
    main_heading: "admin.translation_edit_main_heading",
  },
  form: {
    keyword_label_text: "admin.translation_form_keyword_label_text",
    keyword_placeholder: "admin.translation_form_keyword_placeholder",
    language_label_text : "admin.translation_form_language_label_text",
    value_label_text: "admin.translation_form_value_label_text",
    value_placeholder: "admin.translation_form_value_placeholder",
    add_translation_btn_text: "admin.translation_form_add_translation_btn_text",
    update_translation_btn_text: "admin.translation_form_update_translation_btn_text",
    loading_btn_text: "admin.translation_form_loading_btn_text",
    submit_btn_text: "admin.translation_form_submit_btn_text",
    cancel_btn_text: "admin.translation_form_cancel_btn_text",
  },
};
